export default __webpack_public_path__ + "static/media/lagoon.9fc79838.jpg";